module.exports = __webpack_public_path__ + "img/locais.e5996c97.png";